import { CycleOperations } from 'src/components/dispatch/vehicleRowExpand/sortedOperationIds';
import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/**
 * 並べ替えの保存に渡す「今の回転構成」を delivery から作る。
 *
 * Why 1 operation = 1 place: ここでの place は地点の集約ではなく、operation の
 * 並び順を保つための入れ物。保存リクエストは最終的に operation の一次元列になるので、
 * 地点にまとめても結果は変わらない（まとめる側の責務は展開行 VM が持つ）。
 */
export function buildCyclesFromDelivery(
  delivery: PlanningsDeliveryWithLegRunEntity | undefined,
): CycleOperations[] {
  const operations = delivery?.operations ?? [];
  const byCycle = new Map<number, CycleOperations>();

  operations.forEach((operation) => {
    const cycle = byCycle.get(operation.cycle)
      ?? { cycleIndex: operation.cycle, places: [] };
    // 回転内の順は operations の並びそのまま。番号順に並べ直すと運行順が壊れる
    cycle.places.push({ operationIds: [operation.id] });
    byCycle.set(operation.cycle, cycle);
  });

  // 回転番号は 1,2,3… とは限らない（回転削除の直後など）ので昇順に並べ直す
  return [...byCycle.values()].sort((a, b) => a.cycleIndex - b.cycleIndex);
}
